<template>
  <div>
    <!-- pc端 -->
    <nav
      :class="['header', { 'header-scrolled': scrollShow, 'page-scrolled': pageScrolled }]"
    >
      <div class="nav-box">
        <div class="nav-left">
          <!-- logo -->
          <div class="logo-box">
            <router-link to="/">
              <img class="img-logo" :src="logoImg" />
            </router-link>
          </div>
          <!-- 路由导航 -->
          <div class="nav-list">
            <el-menu
              v-if="menuShow"
              ref="menuRef"
              :default-active="pathUrl"
              :router="true"
              class="el-menu-demo"
              mode="horizontal"
              background-color="rgba(0,0,0,0)"
              :text-color="menuTextColor"
              :active-text-color="menuTextColor"
              popper-class="nav-pup"
                            @select="handleSelect"
            >
              <el-menu-item index="/">首页</el-menu-item>
              <el-submenu
                class="solution-main"
                index="/solution"
                :popper-class="solution"
                :popper-append-to-body="false"
                :hide-timeout="0"
                :show-timeout="0"
                style="display: none;"
              >
                <template slot="title">产品 <i class="el-icon-arrow-down"></i></template>
                <!-- 简化后的下拉菜单结构 -->
                <div class="solution-dropdown">
                  <!-- 左侧产品导航 -->
                  <div class="solution-sidebar">
                    <div class="solution-category" v-for="(item, index) in solutionTitleList" :key="index" @mouseenter="mouseOver(index)" @click="selectSolutionTitle(item)">
                      <img class="category-icon" :src="item.icon" :alt="item.title">
                      <div class="category-info" :class="{'active': index === carouselIndex}">
                        <div class="category-title">
                          {{ item.title }}
                          <img v-if="item.hot" class="hot-badge" src="https://cdn.ideamake.cn/sw-pc/images/web3.0/hot-icon.png" alt="hot" />
                        </div>
                        <div class="category-desc">{{ item.description }}</div>
                      </div>
                    </div>
                    <img class="sidebar-decoration" src="https://cdn.ideamake.cn/sw-pc/images/web3.0/header-title-building.png" alt="">
                  </div>
                  
                  <!-- 右侧内容区 -->
                  <div class="solution-content-area">
                    <!-- 搜索区域 -->
                    <div class="solution-search-area">
                      <el-input
                        class="search-input"
                        placeholder="搜索方案名称"
                        @focus="solutionSearchContentShow = true"
                        @blur="solutionSearchBlur"
                        @input="solutionSearch"
                        v-model.trim="solutionSearchValue"
                      >
                        <img slot="suffix" src="https://cdn.ideamake.cn/sw-pc/images/web3.0/icon-search.png" alt="search" />
                      </el-input>
                      
                      <!-- 搜索结果下拉 -->
                      <transition name="slide-fade">
                        <div v-if="solutionSearchContentShow" class="search-dropdown">
                          <div v-if="solutionSearchValue && !solutionSearchList.length" class="search-empty">
                            <div class="empty-text">暂无搜索结果</div>
                            <div class="hot-title">热门产品<img src="https://cdn.ideamake.cn/sw-pc/images/web3.0/hot-icon.png" alt="热门"></div>
                            <div class="hot-tags">
                              <span v-for="(item, index) in solutionHotList" :key="index" class="hot-tag" @click.stop="handleSolutionSearch(item)">
                                {{ item.text }}
                              </span>
                            </div>
                          </div>
                          <div v-else class="search-results">
                            <div v-show="!solutionSearchValue" class="results-title">热门产品</div>
                            <div v-for="(item, index) in solutionSearchValue ? solutionSearchList : solutionHotList" :key="index" class="result-item" @click="handleSolutionSearch(item)">
                              <span>{{ item.text }}</span>
                            </div>
                          </div>
                        </div>
                      </transition>
                      
                      <!-- 快捷标签 -->
                      <div v-for="(item) in solutionDefaultSearchList" :key="item.text" class="quick-tag" @click.stop="handleSolutionSearch(item)">
                        {{ item.text }}
                      </div>
                    </div>
                    
                    <!-- 产品菜单区域 -->
                    <div class="solution-menus">
                      <el-carousel ref="carousel" height="374px" direction="vertical" indicator-position="none" :initial-index="carouselIndex" :autoplay="false">
                        <el-carousel-item v-for="(solutionTitle) in solutionTitleList" :key="solutionTitle.name">
                          <div class="menu-panel">
                            <div v-for="(item, index) in solutionTitle.children" :key="index" class="menu-group" :style="item.style || {}">
                              <div class="group-title" :style="myStyle(item.icon)" @click="trackerData(item.title)">
                                {{ item.specialTitle || item.title }}
                                <img v-if="item.hot" class="hot-badge" src="https://cdn.ideamake.cn/sw-pc/images/web3.0/hot-icon.png" alt="hot" />
                              </div>
                              <div class="group-items" :class="{'horizontal': item.direction === 'horizontal'}">
                                <div v-for="(list, textIndex) in item.content" :key="textIndex" class="menu-item" @click="goPage({ name: list.text }, true)">
                                  {{ list.text }}
                                  <img v-if="list.hot" class="hot-badge" src="https://cdn.ideamake.cn/sw-pc/images/web3.0/hot-icon.png" alt="hot" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </el-carousel-item>
                      </el-carousel>
                    </div>
                  </div>
                </div>
              </el-submenu>
              <el-submenu
                class="new-product-main"
                index="/new-product"
                :popper-class="'header-nav-popup scrolled new-product'"
                :popper-append-to-body="false"
                :hide-timeout="0"
                :show-timeout="0"
                ref="newProductSubmenu"
              >
                <template slot="title">产品 <i class="el-icon-arrow-down"></i></template>
                <div class="new-product-popup">
                  <div class="new-product-content">
                    <div class="product-sections-wrapper">
                      <div class="category-section left-section">
                        <h2 class="category-title">思为能为您做什么</h2>
                        <div class="product-list vertical">
                          <div class="product-item" @click="handleNewProductClick('omnichannel-acquisition')">
                            <div class="product-image">
                              <img src="@/assets/img/产品方案icon/营销获客.svg" alt="全域获客" />
                            </div>
                            <div class="product-info">
                              <h3 class="product-title">全域获客</h3>
                              <p class="product-subtitle">多通路整合，全域挖线索，破获客难题</p>
                            </div>
                          </div>
                          <div class="product-item" @click="handleNewProductClick('lead-conversion')">
                            <div class="product-image">
                              <img src="@/assets/img/产品方案icon/线索识别.svg" alt="线索管理" />
                            </div>
                            <div class="product-info">
                              <h3 class="product-title">线索管理</h3>
                              <p class="product-subtitle">线索SOP+智能标签，筛客识需求，解线索质量杂难题</p>
                            </div>
                          </div>
                          <div class="product-item" @click="handleNewProductClick('marketing-automation')">
                            <div class="product-image">
                              <img src="@/assets/img/产品方案icon/营销转化.svg" alt="私域运营" />
                            </div>
                            <div class="product-info">
                              <h3 class="product-title">私域运营</h3>
                              <p class="product-subtitle">私域全链路打通，实现增购 + 营销双驱动提转化</p>
                            </div>
                          </div>
                          <div class="product-item" @click="handleNewProductClick('private-domain-growth')">
                            <div class="product-image">
                              <img src="@/assets/img/产品方案icon/私域增值.svg" alt="数据运营" />
                            </div>
                            <div class="product-info">
                              <h3 class="product-title">数据运营</h3>
                              <p class="product-subtitle">盘活客户数据，激活业务价值，挖掘增长机会</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="category-section right-section">
                        <h2 class="category-title">思为产品体系</h2>
                        <div class="product-list grid">
                          <div class="product-item-with-sub">
                            <div class="product-item" @click="handleNewProductClick('community-miniprogram')">
                              <div class="product-image">
                                <img src="@/assets/img/banner产品icon/小程序.png" alt="社群小程序" />
                              </div>
                              <div class="product-info">
                                <h3 class="product-title">小程序</h3>
                                <p class="product-subtitle">激活私域价值</p>
                              </div>
                            </div>
                            <div class="sub-options">
                              <div class="sub-option" @click="handleNewProductClick('community-brand-center')">
                                <span class="sub-option-text">品牌展示</span>
                              </div>
                              <div class="sub-option" @click="handleNewProductClick('community-local-life')">
                                <span class="sub-option-text">社群活动</span>
                              </div>
                              <div class="sub-option" @click="handleNewProductClick('community-viral-engine')">
                                <span class="sub-option-text">线上商城</span>
                              </div>
                              <div class="sub-option" @click="handleNewProductClick('community-viral-engine-2')">
                                <span class="sub-option-text">圈层裂变</span>
                              </div>
                            </div>
                          </div>
                          <div class="product-item-with-sub">
                            <div class="product-item" @click="handleNewProductClick('crm')">
                              <div class="product-image">
                                <img src="@/assets/img/banner产品icon/销冠crm.png" alt="销冠CRM" />
                              </div>
                              <div class="product-info">
                                <h3 class="product-title">销冠CRM</h3>
                                <p class="product-subtitle">智能营销管理</p>
                              </div>
                            </div>
                            <div class="sub-options">
                              <div class="sub-option" @click="handleNewProductClick('crm-public-acquisition')">
                                <span class="sub-option-text">拓客利器</span>
                              </div>
                              <div class="sub-option" @click="handleNewProductClick('crm-leads-management')">
                                <span class="sub-option-text">AI应用</span>
                              </div>
                              <div class="sub-option" @click="handleNewProductClick('crm-private-operation')">
                                <span class="sub-option-text">客户管理</span>
                              </div>
                              <div class="sub-option" @click="handleNewProductClick('crm-team-collaboration')">
                                <span class="sub-option-text">团队协作</span>
                              </div>
                            </div>
                          </div>
                          <div class="product-item-with-sub">
                            <div class="product-item" @click="handleNewProductClick('marketing-cloud')">
                              <div class="product-image">
                                <img src="@/assets/img/banner产品icon/营销云.png" alt="营销云" />
                              </div>
                              <div class="product-info">
                                <h3 class="product-title">营销云</h3>
                                <p class="product-subtitle">数字营销新基建</p>
                              </div>
                            </div>
                            <div class="sub-options">
                              <div class="sub-option" @click="handleNewProductClick('cloud-advertising-center')">
                                <span class="sub-option-text">投放中心</span>
                              </div>
                              <div class="sub-option" @click="handleNewProductClick('cloud-content-center')">
                                <span class="sub-option-text">内容中心</span>
                              </div>
                              <div class="sub-option" @click="handleNewProductClick('cloud-channel-center')">
                                <span class="sub-option-text">渠道中心</span>
                              </div>
                              <div class="sub-option" @click="handleNewProductClick('cloud-data-management')">
                                <span class="sub-option-text">数据管理</span>
                              </div>
                              <div class="sub-option" @click="handleNewProductClick('cloud-transaction-management')">
                                <span class="sub-option-text">交易管理</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="category-divider"></div>
                        <h3 class="category-title">地产行业产品方案</h3>
                        <div class="product-list grid">
                          <div class="product-item-with-sub">
                            <div class="product-item no-click">
                              <div class="product-image">
                                <img src="https://cdn.ideamake.cn/sw-pc/images/web3.0/header-title-smart.png" alt="智慧案场" />
                              </div>
                              <div class="product-info">
                                <h3 class="product-title">智慧案场</h3>
                                <p class="product-subtitle">数字化案场解决方案</p>
                              </div>
                            </div>
                            <div class="sub-options">
                              <div class="sub-option" @click="handleNewProductClick('channel-manage')">
                                <span class="sub-option-text">渠道管理</span>
                              </div>
                              <div class="sub-option" @click="handleNewProductClick('smart-scene')">
                                <span class="sub-option-text">智慧案场</span>
                              </div>
                              <div class="sub-option" @click="handleNewProductClick('transaction-manager')">
                                <span class="sub-option-text">交易管理</span>
                              </div>
                            </div>
                          </div>
                          <div class="product-item-with-sub">
                            <div class="product-item" @click="handleNewProductClick('digital-sandbox')">
                              <div class="product-image">
                                <img src="https://cdn.ideamake.cn/sw-pc/images/web3.0/header-title-sand.png" alt="数字沙盘" />
                              </div>
                              <div class="product-info">
                                <h3 class="product-title">数字沙盘</h3>
                                <p class="product-subtitle">沉浸式看房体验</p>
                              </div>
                            </div>
                            <div class="sub-options">
                              <div class="sub-option" @click="handleNewProductClick('sandbox-ue5-screen')">
                                <span class="sub-option-text">UE5智慧大屏</span>
                              </div>
                              <div class="sub-option" @click="handleNewProductClick('sandbox-ipad-system')">
                                <span class="sub-option-text">iPad售楼系统</span>
                              </div>
                              <div class="sub-option" @click="handleNewProductClick('sandbox-mini-sandbox')">
                                <span class="sub-option-text">微沙盘</span>
                              </div>
                              <div class="sub-option" @click="handleNewProductClick('sandbox-cloud-editor')">
                                <span class="sub-option-text">云创编辑器</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-submenu>
              <el-submenu
                class="industry-main"
                index="/industry"
                :popper-class="'header-nav-popup scrolled industry'"
                :popper-append-to-body="false"
                :hide-timeout="0"
                :show-timeout="0"
                ref="industrySubmenu"
              >
                <template slot="title">解决方案 <i class="el-icon-arrow-down"></i></template>
                <div class="industry-popup">
                  <div class="industry-content">
                    <div class="category-section">
                      <h2 class="category-title">行业解决方案</h2>
                      <div class="solution-list">
                        <div class="solution-item" @click="handleIndustryClick('real-estate')">
                          <div class="solution-image">
                            <img src="@/assets/img/产品方案icon/房地产.svg" alt="房地产" />
                          </div>
                          <div class="solution-info">
                            <h3 class="solution-title">房地产</h3>
                            <p class="solution-subtitle">地产行业数字化解决方案</p>
                          </div>
                        </div>
                        <div class="solution-item" @click="handleIndustryClick('automotive')">
                          <div class="solution-image">
                            <img src="@/assets/img/产品方案icon/汽车.svg" alt="汽车" />
                          </div>
                          <div class="solution-info">
                            <h3 class="solution-title">汽车</h3>
                            <p class="solution-subtitle">汽车行业营销解决方案</p>
                          </div>
                        </div>
                        <div class="solution-item" @click="handleIndustryClick('healthcare')">
                          <div class="solution-image">
                            <img src="@/assets/img/产品方案icon/大健康.svg" alt="大健康" />
                          </div>
                          <div class="solution-info">
                            <h3 class="solution-title">大健康</h3>
                            <p class="solution-subtitle">健康产业数字化转型</p>
                          </div>
                        </div>
                        <div class="solution-item" @click="handleIndustryClick('education')">
                          <div class="solution-image">
                            <img src="@/assets/img/产品方案icon/教育.svg" alt="教育" />
                          </div>
                          <div class="solution-info">
                            <h3 class="solution-title">教育</h3>
                            <p class="solution-subtitle">教育行业智能营销</p>
                          </div>
                        </div>
                        <div class="solution-item" @click="handleIndustryClick('home-decoration')">
                          <div class="solution-image">
                            <img src="@/assets/img/产品方案icon/家装.svg" alt="家装" />
                          </div>
                          <div class="solution-info">
                            <h3 class="solution-title">家装</h3>
                            <p class="solution-subtitle">家装行业获客解决方案</p>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </el-submenu>
              <el-menu-item index="/real-estate">房地产</el-menu-item>
              <el-menu-item index="/cases">成功案例</el-menu-item>
              <el-menu-item index="/watch" @click="goSWG" style="display: none;">思为观</el-menu-item>

              <el-menu-item index="/about">关于思为</el-menu-item>


              <!-- <el-submenu
                index="/about"
                :popper-class="popperClass"
                :popper-append-to-body="false"
                :hide-timeout="0"
              >
                <template slot="title">关于我们</template>
                <el-menu-item index="/about">关于思为</el-menu-item>
                <el-menu-item @click="goJoin">加入我们</el-menu-item>
              <el-menu-item index="/partner">合作伙伴</el-menu-item> 
              </el-submenu> -->
               
            </el-menu>
          </div>
        </div>
        <!-- 电话、立即体验 -->
        <div class="nav-right">
          <div class="phone">
            <img class="phone-img" :src="phoneImg" />
            <!-- :style="{ color: this.scrollShow || this.back ? '#2D2E30' : '' }" -->
            <span
              :style="{ color:'#2D2E30'}"
              >400-8075-618</span
            >
          </div>
          <div class="go-experience" @click="goReservation">立即体验</div>
        </div>
      </div>
    </nav>
    <!-- 移动端 -->
    <nav class="min-header-box">
      <div class="min-header">
        <div class="min-logo-box">
          <img
            class="img-logo"
            src="https://cdn.ideamake.cn/sw-pc/images/header_logo_black.png"
          />
        </div>
        <div class="min-nav-right">
          <img
            class="min-nav-icon min-nav-phone"
            @click="callPhone"
            src="https://cdn.ideamake.cn/sw-pc/images/min-phone/min_phone.png"
          />
          <img
            class="min-nav-icon min-nav-list"
            @click="showPopup"
            src="https://cdn.ideamake.cn/sw-pc/images/min-phone/min_list.png"
          />
        </div>
      </div>
      <!-- 下拉导航栏 -->
      <van-popup v-model="minNavShow" position="top">
        <div class="min-nav-popup" :style="{marginBottom: (newProductPopupShow || industryPopupShow) ? '1.32rem' : 0}">
          <ul class="navpopup-list">
                          <li
                :class="['popup-list-item', { active: pathUrl === '/' }]"
                @click="goRoute('/')"
              >
                首页
              </li>

            <li
              :class="[
                'popup-list-item',
                'popup',
                { 'popup-show': newProductPopupShow },
                { active: pathUrl.indexOf('/solution') !== -1 },
              ]"
              @click="showNewProductPopup"
            >
              产品
            </li>
            <div class="item-popup new-product" v-show="newProductPopupShow">
              <div class="item-popup-wrap">
                <div class="popup-text-title">思为能为您做什么</div>
                <div class="popup-items-container">
                  <span class="popup-text-item" @click="goRoute('/solution/omnichannel-acquisition')">
                    <img src="@/assets/img/产品方案icon/营销获客.svg" alt="全域获客" class="mobile-menu-icon" />
                    全域获客
                  </span>
                  <span class="popup-text-item" @click="goRoute('/solution/lead-conversion')">
                    <img src="@/assets/img/产品方案icon/线索识别.svg" alt="线索管理" class="mobile-menu-icon" />
                    线索管理
                  </span>
                  <span class="popup-text-item" @click="goRoute('/solution/marketing-automation')">
                    <img src="@/assets/img/产品方案icon/营销转化.svg" alt="私域运营" class="mobile-menu-icon" />
                    私域运营
                  </span>
                  <span class="popup-text-item" @click="goRoute('/solution/private-domain-growth')">
                    <img src="@/assets/img/产品方案icon/私域增值.svg" alt="数据运营" class="mobile-menu-icon" />
                    数据运营
                  </span>
                </div>
              </div>
              <div class="item-popup-wrap">
                <div class="popup-text-title">思为产品体系</div>
                <div class="popup-items-container">
                  <span class="popup-text-item" @click="goRoute('/solution/community-miniprogram')">
                    <img src="@/assets/img/banner产品icon/小程序.png" alt="小程序" class="mobile-menu-icon" />
                    小程序
                  </span>
                  <span class="popup-text-item" @click="goRoute('/solution/crm')">
                    <img src="@/assets/img/banner产品icon/销冠crm.png" alt="销冠CRM" class="mobile-menu-icon" />
                    销冠CRM
                  </span>
                  <span class="popup-text-item" @click="goRoute('/solution/marketing-cloud')">
                    <img src="@/assets/img/banner产品icon/营销云.png" alt="营销云" class="mobile-menu-icon" />
                    营销云
                  </span>
                </div>
              </div>
              <!-- 小程序子功能 - 移动端隐藏 -->
              <!-- <div class="item-popup-wrap">
                <div class="popup-text-title">小程序子功能</div>
                <span class="popup-text-item" @click="goRoute('/solution/community-miniprogram?index=0')">品牌展示</span>
                <span class="popup-text-item" @click="goRoute('/solution/community-miniprogram?index=1')">社群活动</span>
                <span class="popup-text-item" @click="goRoute('/solution/community-miniprogram?index=2')">线上商城</span>
                <span class="popup-text-item" @click="goRoute('/solution/community-miniprogram?index=3')">圈层裂变</span>
              </div> -->
              <!-- 销冠CRM子功能 - 移动端隐藏 -->
              <!-- <div class="item-popup-wrap">
                <div class="popup-text-title">销冠CRM子功能</div>
                <span class="popup-text-item" @click="goRoute('/solution/crm?index=0')">拓客利器</span>
                <span class="popup-text-item" @click="goRoute('/solution/crm?index=1')">AI应用</span>
                <span class="popup-text-item" @click="goRoute('/solution/crm?index=2')">客户管理</span>
                <span class="popup-text-item" @click="goRoute('/solution/crm?index=3')">团队协作</span>
              </div> -->
              <!-- 营销云子功能 - 移动端隐藏 -->
              <!-- <div class="item-popup-wrap">
                <div class="popup-text-title">营销云子功能</div>
                <span class="popup-text-item" @click="goRoute('/solution/precise-customer')">全渠道获客</span>
                <span class="popup-text-item" @click="goRoute('/solution/customer-precipitate')">社群运营</span>
                <span class="popup-text-item" @click="goRoute('/solution/intelligent-operate')">营销自动化</span>
                <span class="popup-text-item" @click="goRoute('/solution/data-insight')">管理驾驶舱</span>
              </div> -->
              <div class="item-popup-wrap">
                <div class="popup-text-title">地产行业产品方案</div>
                <div class="popup-items-container">
                  <span class="popup-text-item" @click="goRoute('/solution/smart-scene')">
                    <img src="https://cdn.ideamake.cn/sw-pc/images/web3.0/header-title-smart.png" alt="智慧案场" class="mobile-menu-icon" />
                    智慧案场
                  </span>
                  <span class="popup-text-item" @click="goRoute('/solution/visual-display')">
                    <img src="https://cdn.ideamake.cn/sw-pc/images/web3.0/header-title-sand.png" alt="数字沙盘" class="mobile-menu-icon" />
                    数字沙盘
                  </span>
                </div>
              </div>
              <!-- 智慧案场子功能 - 移动端隐藏 -->
              <!-- <div class="item-popup-wrap">
                <div class="popup-text-title">智慧案场子功能</div>
                <span class="popup-text-item" @click="goRoute('/solution/channel-manage')">渠道管理</span>
                <span class="popup-text-item" @click="goRoute('/solution/smart-scene')">智慧案场</span>
                <span class="popup-text-item" @click="goRoute('/solution/transaction-manager')">交易管理</span>
              </div> -->
              <!-- 数字沙盘子功能 - 移动端隐藏 -->
              <!-- <div class="item-popup-wrap">
                <div class="popup-text-title">数字沙盘子功能</div>
                <span class="popup-text-item" @click="goRoute('/solution/visual-display?index=0')">UE5智慧大屏</span>
                <span class="popup-text-item" @click="goRoute('/solution/visual-display?index=1')">iPad售楼系统</span>
                <span class="popup-text-item" @click="goRoute('/solution/visual-display?index=2')">微沙盘</span>
                <span class="popup-text-item" @click="goRoute('/solution/visual-display?index=3')">云创编辑器</span>
              </div> -->
            </div>
            <li
              :class="[
                'popup-list-item',
                'popup',
                { 'popup-show': industryPopupShow },
                { active: pathUrl.indexOf('/industry') !== -1 },
              ]"
              @click="showIndustryPopup"
            >
              解决方案
            </li>
            <div class="item-popup industry" v-show="industryPopupShow">
              <div class="item-popup-wrap">
                <div class="popup-text-title">行业解决方案</div>
                <div class="popup-items-container">
                  <span class="popup-text-item" @click="goRoute('/industry/real-estate')">
                    <img src="@/assets/img/产品方案icon/房地产.svg" alt="房地产" class="mobile-menu-icon" />
                    房地产
                  </span>
                  <span class="popup-text-item" @click="goRoute('/industry/automotive')">
                    <img src="@/assets/img/产品方案icon/汽车.svg" alt="汽车" class="mobile-menu-icon" />
                    汽车
                  </span>
                  <span class="popup-text-item" @click="goRoute('/industry/healthcare')">
                    <img src="@/assets/img/产品方案icon/大健康.svg" alt="大健康" class="mobile-menu-icon" />
                    大健康
                  </span>
                  <span class="popup-text-item" @click="goRoute('/industry/education')">
                    <img src="@/assets/img/产品方案icon/教育.svg" alt="教育" class="mobile-menu-icon" />
                    教育
                  </span>
                  <span class="popup-text-item" @click="goRoute('/industry/home-decoration')">
                    <img src="@/assets/img/产品方案icon/家装.svg" alt="家装" class="mobile-menu-icon" />
                    家装
                  </span>
                </div>
              </div>
            </div>

            <li
              :class="['popup-list-item', { active: pathUrl === '/cases' }]"
              @click="goRoute('/cases')"
            >
              成功案例
            </li>
            <!-- <li class="popup-list-item" @click="goSWG">思为观</li> -->

            <li
              :class="['popup-list-item', { active: pathUrl === '/about' }]"
              @click="goRoute('/about')"
            >
            关于我们
            </li>
          </ul>
          <!-- <div class="go-experience" @click="goReservation">立即体验</div> -->
        </div>
      </van-popup>
    </nav>
  </div>
</template>

<script>
import { jsonp } from 'vue-jsonp';
import utils from '@/utils';
import { solutionList, solutionDefaultSearchList } from '@/components/constant'

export default {
  name: 'SwHeader',
  components: {},
  data() {
    return {
      observer: null,
      scrollShow: false, // 导航栏样式状态（包含滚动和悬浮）
      pageScrolled: false, // 纯页面滚动状态
      menuHovered: false, // 菜单悬浮状态
      menuOpened: false, // 下拉菜单展开状态
      pathUrl: '/', // 当前路径
      menuShow: true,
      minNavShow: false,
      newProductPopupShow: false, // 产品下拉
      industryPopupShow: false, // 行业解决方案下拉
      aboutPopupshow: false, // 关于我们下拉
      solutionSearchContentShow: false, // 产品与解决方案搜索内容框展示
      carouselShow: false,
      state2: '',
      solutionList,
      solutionSearchValue: '',
      solutionSearchList: [],
      solutionDefaultSearchList,
      carouselIndex: 0, // PC端轮播当前轮播页
    }
  },
  computed: {
    logoImg() {
      // return this.scrollShow || this.back
      //   ? 'https://cdn.ideamake.cn/sw-pc/images/header_logo_black.png'
      //   : 'https://cdn.ideamake.cn/sw-pc/images/header_logo_white.png';
      return 'https://cdn.ideamake.cn/sw-pc/images/header_logo_black.png'
    },
    phoneImg() {
      // return this.scrollShow || this.back
      //   ? 'https://cdn.ideamake.cn/sw-pc/images/phone_black.png'
      //   : 'https://cdn.ideamake.cn/sw-pc/images/phone_white.png';
      return 'https://cdn.ideamake.cn/sw-pc/images/phone_black.png'
    },
    // menuBackgroundColor() {
    //   return this.scrollShow ? '#FFFFFF' : 'rgba(0,0,0,0)';
    // },
    menuTextColor() {
      // return this.scrollShow || this.back ? '#2D2E30' : '#FFFFFF';

      return '#2D2E30'

    },
    popperClass() {
      return this.scrollShow ? 'header-nav-popup scrolled' : 'header-nav-popup';
    },
    solution() {
      return 'header-nav-popup scrolled solution';
    },
    myStyle() {
      return (val) => {
        // icon 有可能为undefined，this.solutionList有{}主要用于占位
        if (!val) { 
          return {}
        }
        return `--my-var: url(${val}); background-image: var(--my-var); background-repeat: no-repeat; background-size: 16px 16px;`;
      };
    },
    back() {
      let data = true;
      if (this.pathUrl === '/about' || this.pathUrl === '/cases' ) {
        data = false;
      }
      return data;
    },
    // 带有hot标签的菜单
    solutionHotList () {
      const list = this.solutionList.reduce((prev, cur) => {
        return prev.concat((cur.content ?? []).map((subMenu, index) => ({
          ...subMenu,
          index,
          title: cur.title,
          text: subMenu.text,
          code: cur.code,
          parentName: cur.parentName
        })).filter(subMenu => subMenu.hot))
      }, [])
      return this.getRandomValues(list, 6)
    },
    // 产品与解决方案菜单左边4个大菜单
    solutionTitleList () {
      const list = [
              {
          icon: '@/assets/img/banner产品icon/小程序.png',
          title: '社群小程序',
          description: '重构社群生态，激活私域价值',
          name: 'communityMiniProgram',
          hot: true,
        },
        {
          icon: '@/assets/img/banner产品icon/销冠crm.png',
          title: '销冠CRM',
          description: '更智能的营销CRM',
          name: 'crm',
          hot: true,
        },
        {
          icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-title-smart.png',
          title: '智慧案场',
          description: '营销一体化数字案场解决方案',
          name: 'smartField',
        },
        {
          icon: '@/assets/img/banner产品icon/营销云.png',
          title: '营销云',
          description: '构建数字新基建，推动商业新文明',
          name: 'marketCloud',
        },
        {
          icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-title-sand.png',
          title: '数字沙盘',
          description: '楼盘方寸间，看房零局限',
          name: 'digitalSandTable',
        },


      ]
      return list.map(item => {
        item.children = this.solutionList.filter(menu => menu.parentName === item.name)
        return item
      })
    }
  },
  watch: {
    '$route.path'() {
      this.pathUrl = utils.changeRoutePath(this.$route.path);
      // 刷新组件防止选中BUG
      if (['/experience', '/reservation'].includes(this.pathUrl)) {
        this.menuShow = false;
        setTimeout(() => {
          this.menuShow = true;
          this.$nextTick(() => {
            const targetElement = document.querySelector('.el-menu--horizontal.header-nav-popup.scrolled.solution')
            this.observer.disconnect()
            this.observer.observe(targetElement, { attributes: true, attributeFilter: ['style'] });
          })
        }, 1);
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    this.observer.disconnect();
    this.removeMenuHoverListeners();
  },
  created() {
    this.pathUrl = utils.changeRoutePath(this.$route.path);
    window.addEventListener('scroll', this.handleScroll);
    this.getLocation();
  },

  mounted() {
    // 监听
    this.observer = new MutationObserver(utils.debounce((mutationsList) => {
      if (mutationsList.length) {
        const mutation = mutationsList[0]
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          const targetElement = mutation.target;
          const displayValue = targetElement.style.display;
          this.carouselShow = displayValue !== 'none'
        }
      }
    }, 50));
    const targetElement = document.querySelector('.el-menu--horizontal.header-nav-popup.scrolled.solution')
    this.observer.observe(targetElement, { attributes: true, attributeFilter: ['style'] });
    
    // 为菜单项添加鼠标事件监听器
    this.$nextTick(() => {
      this.addMenuHoverListeners();
    });
  },
  methods:{
        addMenuHoverListeners() {
      // 为"产品"菜单项添加事件监听器
      const newProductSubmenu = this.$refs.newProductSubmenu;
      if (newProductSubmenu && newProductSubmenu.$el) {
        const titleElement = newProductSubmenu.$el.querySelector('.el-submenu__title');
        if (titleElement) {
          titleElement.addEventListener('mouseenter', this.menuMouseenter);
          titleElement.addEventListener('mouseleave', this.menuMouseleave);
        }
        
        // 监听下拉菜单展开状态
        this.setupMenuOpenObserver(newProductSubmenu.$el);
      }
      
      // 为"解决方案"菜单项添加事件监听器
      const industrySubmenu = this.$refs.industrySubmenu;
      if (industrySubmenu && industrySubmenu.$el) {
        const titleElement = industrySubmenu.$el.querySelector('.el-submenu__title');
        if (titleElement) {
          titleElement.addEventListener('mouseenter', this.menuMouseenter);
          titleElement.addEventListener('mouseleave', this.menuMouseleave);
        }
        
        // 监听下拉菜单展开状态
        this.setupMenuOpenObserver(industrySubmenu.$el);
      }
    },
    setupMenuOpenObserver(submenuElement) {
      // 创建MutationObserver来监听submenu类名变化
      const observer = new MutationObserver((mutations) => {
                 mutations.forEach((mutation) => {
           if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
             const target = mutation.target;
             const isOpen = target.classList.contains('is-opened');
             
             if (isOpen && !this.menuOpened) {
               this.menuOpened = true;
               this.updateScrollShow();
             } else if (!isOpen && this.menuOpened) {
               // 检查是否还有其他菜单开着
               const allSubmenus = document.querySelectorAll('.el-submenu.is-opened');
               if (allSubmenus.length === 0) {
                 this.menuOpened = false;
                 this.updateScrollShow();
               }
             }
           }
         });
      });
      
      observer.observe(submenuElement, {
        attributes: true,
        attributeFilter: ['class']
      });
      
      // 保存observer引用以便后续清理
      if (!this.menuObservers) {
        this.menuObservers = [];
      }
      this.menuObservers.push(observer);
    },
     removeMenuHoverListeners() {
       // 移除"产品"菜单项的事件监听器
       const newProductSubmenu = this.$refs.newProductSubmenu;
       if (newProductSubmenu && newProductSubmenu.$el) {
         const titleElement = newProductSubmenu.$el.querySelector('.el-submenu__title');
         if (titleElement) {
           titleElement.removeEventListener('mouseenter', this.menuMouseenter);
           titleElement.removeEventListener('mouseleave', this.menuMouseleave);
         }
       }
       
       // 移除"解决方案"菜单项的事件监听器
       const industrySubmenu = this.$refs.industrySubmenu;
       if (industrySubmenu && industrySubmenu.$el) {
         const titleElement = industrySubmenu.$el.querySelector('.el-submenu__title');
         if (titleElement) {
           titleElement.removeEventListener('mouseenter', this.menuMouseenter);
           titleElement.removeEventListener('mouseleave', this.menuMouseleave);
         }
       }
       
       // 清理menuObservers
       if (this.menuObservers) {
         this.menuObservers.forEach(observer => observer.disconnect());
         this.menuObservers = [];
       }
     },
     handleSelect(key, path) {
      switch (path) {
        case ['/']:
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏首页',
          ]);
          break;
        case ['/industry']:
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏解决方案',
          ]);
          break;
        case ['/real-estate']:
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏房地产',
          ]);
          break;
        case ['/cases']:
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏成功案例',
          ]);
          break;
        case ['/watch']:
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏思为观',
          ]);
          break;
        case ['/new-product']:
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏新产品',
          ]);
          break;
        case ['/about', '/about']:
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏关于我们关于思为',
          ]);
          break;
      }
    },
    trackerData(title) {
      window._hmt.push([
        '_trackEvent',
        'button',
        'click',
        `头部导航栏产品与解决方案下拉菜单二级导航${title}`,
      ]);
    },
    trackerIndustry(title) {
      window._hmt.push([
        '_trackEvent',
        'button',
        'click',
        `头部导航栏解决方案下拉菜单${title}`,
      ]);
    },
    filterSolutionListByKeyWord (keyword, solutionList) {
      let list = []
      let firstMenuParentName = ''
      let firstMenuCode = ''
      const findKeyWord = (curList, isFirstMenu = true, keyConfig) => {
        curList.forEach((menu, index) => {
          if (menu[keyConfig.label]) {
            const { matchCount, target } = this.fuzzySearch(keyword, menu[keyConfig.label])
            if (isFirstMenu) {
              firstMenuParentName = menu.parentName
              firstMenuCode = menu.code
            }
            if (matchCount > 0) list.push({
              ...menu,
              matchCount, 
              text: target,
              isFirstMenu,
              index,
              code: firstMenuCode,
              parentName: firstMenuParentName
            })
            if (Array.isArray(menu[keyConfig.children]) && menu[keyConfig.children].length) {
              findKeyWord(menu[keyConfig.children], false, { label: 'text', children: 'content' })
            }
          }
        })
      }
      findKeyWord(solutionList, true, { label: 'title', children: 'content' })
      list.sort((a, b) => b.matchCount - a.matchCount)
      return list
    },
    handleSolutionSearch(item) {
      if (item.text === this.solutionSearchValue) return
      this.solutionSearch(item.text)
      if (item.isFirstMenu) {
        this.goPage({ path: item.code })
      } else {
        this.goPage({ path: item.code, query: item.parentName === 'crm' ? { subIndex: item.index } : { index: item.index } })
      }
      // 关闭菜单
      this.$nextTick(() => {
        this.$refs.menuRef.close('/solution')
      })
    },
    solutionSearchBlur () {
      // 太快关闭会使得列表消失而导致点击事件失效
      setTimeout(() => {
        this.solutionSearchContentShow = false
        this.solutionSearchValue = ''
      }, 100);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    // 获取当前定位并存储【后续使用】
    getLocation() {
      var data = { key: 'WDTBZ-EOPRG-5ONQY-IDVMO-NXIIK-C4B7A' };
      var url = 'https://apis.map.qq.com/ws/location/v1/ip'; //这个就是地理位置信息的接口
      data.output = 'jsonp';
      jsonp(url, data)
        .then((res) => {
          const ipAddress = res.result.ip;
          const ad_info = res.result.ad_info;
          const { nation, province, city, district } = ad_info;
          const addressInfo = nation + province + city + district;
          sessionStorage.setItem('ip_address', ipAddress);
          sessionStorage.setItem('info_address', addressInfo);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    menuMouseenter() {
      // 鼠标悬浮在下拉菜单项时启用毛玻璃效果
      this.menuHovered = true;
      this.updateScrollShow();
    },
    menuMouseleave() {
      // 离开下拉菜单项时根据页面滚动状态决定是否保持效果
      this.menuHovered = false;
      this.updateScrollShow();
    },
    updateScrollShow() {
      // 更新scrollShow状态：页面滚动、菜单悬浮或菜单展开时显示
      this.scrollShow = this.pageScrolled || this.menuHovered || this.menuOpened;
      
      // 更新has-dropdown类来控制全屏背景
      this.$nextTick(() => {
        const navElement = this.$el.querySelector('nav.header');
        if (navElement) {
          if (this.menuOpened) {
            navElement.classList.add('has-dropdown');
          } else {
            navElement.classList.remove('has-dropdown');
          }
        }
      });
    },

    handleScroll() {
      // 处理页面滚动状态
      this.pageScrolled = window.pageYOffset > 0;
      this.updateScrollShow();
    },
    selectSolutionTitle (item) {
      if (['digitalSandTable', 'crm', 'marketCloud'].includes(item.name)) {
        this.$router.push({ path: item.children?.[0]?.code.split('?')[0] });
      }
    },
    // 跳转思为观
    goSWG() {
      window.open('https://research.ideamake.cn/', '_blank')
    },
    // 跳转加入我们
    goJoin() {
      window._hmt.push([
        '_trackEvent',
        'button',
        'click',
        '头部导航栏关于我们加入我们',
      ]);
      window.open('https://ideamake.zhiye.com/home', '_blank');
    },
    // 跳转立即体验
    goExperience() {
      this.minNavShow = false;
      this.$router.push({ path: '/experience' });
    },
    // 跳转预约演示
    goReservation() {
      window._hmt.push([
        '_trackEvent',
        'button',
        'click',
        '头部导航栏立即体验按钮',
      ]);
      this.$router.push({ path: '/reservation', params: { type: 1 } });
     
    },
    // 跳转
    goPage(data, isOnlyTrack = false) {
      // console.log(data,'data')
      window._hmt.push([
        '_trackEvent',
        'button',
        'click',
        `头部导航栏产品与解决方案下拉菜单三级导航${data.name}`,
      ]);
      !isOnlyTrack && this.$router.push(data);
    },
    // 模糊搜索
    fuzzySearch(keyword, target) {
      // 将关键词转换为小写，以便不区分大小写
      keyword = keyword.toLowerCase();
      target = target.toLowerCase()
      let matchCount = 0;
      // 遍历目标字符串数组
      for (let i = 0; i < target.length; i++) {
        const singleTarget = target[i];
        // 检查目标字符串是否包含关键词的每个字符
        for (let j = 0; j < keyword.length; j++) {
          if (singleTarget.indexOf(keyword[j]) !== -1) {
            matchCount++;
            break
          }
        }
      }
      // 返回排序后的目标字符串数组
      return { matchCount, target }
    },
    solutionSearch: utils.debounce(function (keyWord) {
      this.solutionSearchList = this.filterSolutionListByKeyWord(keyWord, this.solutionList)
    }, 30),
    getRandomValues(array, count) {
      array = [...array]
      const result = []
      for (let i = 0; i < count; i++) {
        const randomIndex = Math.floor(Math.random() * array.length)
        const randomValue = array.splice(randomIndex, 1)[0]
        result.push(randomValue)
      }
      return result;
    },

    // 移动端配置
    // 调用拨号功能
    callPhone() {
      window._hmt.push([
        '_trackEvent',
        'button',
        'click',
        '移动端顶部手机图标按钮',
      ]);
      window.location.href = 'tel://' + '400-8075-618';
    },
    showPopup() {
      window._hmt.push([
        '_trackEvent',
        'button',
        'click',
        '移动端顶部菜单图标按钮',
      ]);
      this.minNavShow = !this.minNavShow;
    },
    goRoute(routePath) {
      console.log(
        '%c [  ]-605',
        'font-size:13px; background:pink; color:#bf2c9f;',
        routePath
      );
      switch (routePath) {
        case '/home':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏首页',
          ]);
          break;
        case '/industry':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏解决方案',
          ]);
          break;
        case '/industry/real-estate':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏解决方案房地产',
          ]);
          break;
        case '/industry/automotive':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏解决方案汽车',
          ]);
          break;
        case '/industry/healthcare':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏解决方案大健康',
          ]);
          break;
        case '/industry/education':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏解决方案教育',
          ]);
          break;
        case '/industry/home-decoration':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏解决方案家装',
          ]);
          break;
        case '/':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏房地产',
          ]);
          break;
        case '/cases':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏成功案例',
          ]);
          break;
        case '/about':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏关于我们关于思为',
          ]);
          break;
        case '/solution/crm':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏产品与解决方案下拉菜单二级导航销冠CRM',
          ]);
          break;
        case '/solution/precise-customer':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏产品与解决方案下拉菜单二级导航全渠道获客',
          ]);
          break;
        case '/solution/marketing-cloud':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏产品与解决方案下拉菜单二级导航营销云',
          ]);
          break;
        case '/solution/channel-manage':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏产品与解决方案下拉菜单二级导航渠道管理',
          ]);
          break;
        case '/solution/intelligent-operate':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏产品与解决方案下拉菜单二级导航营销自动化',
          ]);
          break;
        case '/solution/smart-scene':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏产品与解决方案下拉菜单二级导航智慧案场',
          ]);
          break;
        case '/solution/customer-precipitate':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏产品与解决方案下拉菜单二级导航社群运营',
          ]);
          break;
        case '/solution/data-insight':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏产品与解决方案下拉菜单二级导航管理驾驶舱',
          ]);
          break;
        case '/solution/sales-empowerment':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏产品与解决方案下拉菜单二级导航销售赋能',
          ]);
          break;
        case '/solution/visual-display':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏产品与解决方案下拉菜单二级导航视觉展示',
          ]);
          break;
        case '/solution/member-marketing':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏解决方案会员营销',
          ]);
          break;
        case '/solution/omnichannel-acquisition':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏解决方案全渠道获客',
          ]);
          break;
        case '/solution/lead-conversion':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏解决方案线索跟进转化',
          ]);
          break;
        case '/solution/marketing-automation':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏解决方案自动化营销',
          ]);
          break;
        case '/solution/private-domain-growth':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏解决方案私域资产持续增值',
          ]);
          break;
        case '/solution/community-miniprogram':
          window._hmt.push([
            '_trackEvent',
            'button',
            'click',
            '头部导航栏解决方案社群小程序',
          ]);
          break;
      }
      console.log(
        '%c [  ]-609',
        'font-size:13px; background:pink; color:#bf2c9f;',
        routePath
      );
      this.minNavShow = false;
      this.$router.push({ path: routePath });
    },
    showNewProductPopup() {
      this.newProductPopupShow = !this.newProductPopupShow;
      this.industryPopupShow = false; // 关闭其他下拉菜单
    },
    showIndustryPopup() {
      this.industryPopupShow = !this.industryPopupShow;
      this.newProductPopupShow = false; // 关闭其他下拉菜单
    },
    showAboutPopup() {
      this.aboutPopupshow = !this.aboutPopupshow;
    },

    handleNewProductClick(productType) {
      window._hmt.push([
        '_trackEvent',
        'button',
        'click',
        `头部导航栏新产品下拉菜单${productType}`,
      ]);
      
      // 关闭下拉菜单
      this.$nextTick(() => {
        this.$refs.menuRef.close('/new-product')
      })
      
      switch (productType) {
        // 应用场景产品
        case 'member-marketing':
          this.$router.push({ path: '/solution/member-marketing' });
          break;
        case 'omnichannel-acquisition':
          this.$router.push({ path: '/solution/omnichannel-acquisition' });
          break;
        case 'lead-conversion':
          this.$router.push({ path: '/solution/lead-conversion' });
          break;
        case 'marketing-automation':
          this.$router.push({ path: '/solution/marketing-automation' });
          break;
        case 'private-domain-growth':
          this.$router.push({ path: '/solution/private-domain-growth' });
          break;
        // 应用产品
        case 'community-miniprogram':
          this.$router.push({ path: '/solution/community-miniprogram' });
          break;
        case 'community-brand-center':
          this.$router.push({ path: '/solution/community-miniprogram', query: { index: 0 } });
          break;
        case 'community-local-life':
          this.$router.push({ path: '/solution/community-miniprogram', query: { index: 1 } });
          break;
        case 'community-viral-engine':
          this.$router.push({ path: '/solution/community-miniprogram', query: { index: 2 } });
          break;
        case 'community-viral-engine-2':
          this.$router.push({ path: '/solution/community-miniprogram', query: { index: 3 } });
          break;
        case 'crm':
          this.$router.push({ path: '/solution/crm' });
          break;
        case 'crm-public-acquisition':
          this.$router.push({ path: '/solution/crm', query: { index: 0 } });
          break;
        case 'crm-leads-management':
          this.$router.push({ path: '/solution/crm', query: { index: 1 } });
          break;
        case 'crm-private-operation':
          this.$router.push({ path: '/solution/crm', query: { index: 2 } });
          break;
        case 'crm-team-collaboration':
          this.$router.push({ path: '/solution/crm', query: { index: 3 } });
          break;
        case 'smart-field':
          this.$router.push({ path: '/solution/smart-scene' });
          break;
        case 'channel-manage':
          this.$router.push({ path: '/solution/channel-manage' });
          break;
        case 'smart-scene':
          this.$router.push({ path: '/solution/smart-scene' });
          break;
        case 'transaction-manager':
          this.$router.push({ path: '/solution/transaction-manager' });
          break;
        case 'marketing-cloud':
          this.$router.push({ path: '/solution/marketing-cloud' });
          break;
        case 'cloud-advertising-center':
          this.$router.push({ path: '/solution/marketing-cloud', query: { index: 0 } });
          break;
        case 'cloud-content-center':
          this.$router.push({ path: '/solution/marketing-cloud', query: { index: 1 } });
          break;
        case 'cloud-channel-center':
          this.$router.push({ path: '/solution/marketing-cloud', query: { index: 2 } });
          break;
        case 'cloud-data-management':
          this.$router.push({ path: '/solution/marketing-cloud', query: { index: 3 } });
          break;
        case 'cloud-transaction-management':
          this.$router.push({ path: '/solution/marketing-cloud', query: { index: 4 } });
          break;
        case 'digital-sandbox':
          this.$router.push({ path: '/solution/visual-display' });
          break;
        case 'sandbox-ue5-screen':
          this.$router.push({ path: '/solution/visual-display', query: { index: 0 } });
          break;
        case 'sandbox-ipad-system':
          this.$router.push({ path: '/solution/visual-display', query: { index: 1 } });
          break;
        case 'sandbox-mini-sandbox':
          this.$router.push({ path: '/solution/visual-display', query: { index: 2 } });
          break;
        case 'sandbox-cloud-editor':
          this.$router.push({ path: '/solution/visual-display', query: { index: 3 } });
          break;
        default:
          // 其他产品暂时显示提示
          alert('敬请期待！该产品即将上线');
      }
    },
    mouseOver (index) {
      this.carouselIndex = index
      this.$refs.carousel.setActiveItem(index)
    },
    handleIndustryClick(industryType) {
      window._hmt.push([
        '_trackEvent',
        'button',
        'click',
        `头部导航栏解决方案下拉菜单${industryType}`,
      ]);
      
      // 关闭下拉菜单
      this.$nextTick(() => {
        this.$refs.menuRef.close('/industry')
      })
      
      switch (industryType) {
        // 行业解决方案
        case 'real-estate':
          this.$router.push({ path: '/industry/real-estate' });
          break;
        case 'automotive':
          this.$router.push({ path: '/industry/automotive' });
          break;
        case 'healthcare':
          this.$router.push({ path: '/industry/healthcare' });
          break;
        case 'education':
          this.$router.push({ path: '/industry/education' });
          break;
        case 'home-decoration':
          this.$router.push({ path: '/industry/home-decoration' });
          break;
        default:
          console.log('Unknown industry type:', industryType);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
nav.header {
  width: 100%;
  height: 62px;
  overflow: hidden;
  padding: 4px 0 0 0;
  box-sizing: border-box;
  position: fixed;
  color: #ffffff;
  -webkit-transition: color 0.3s ease-in-out, padding 0.3s ease-in-out;
  transition: color 0.3s ease-in-out, padding 0.3s ease-in-out;
  z-index: 500;
  
  /* 添加伪元素用于背景过渡效果 */
  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 100vh;
    background: rgba(232, 232, 237, 0.4);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    z-index: -1;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 1);
    z-index: -1;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  &.header-scrolled {
    color: #2d2e30;
    
    /* 显示导航栏白色背景 */
    &::after {
      opacity: 1;
    }
    
    /* 当有下拉菜单打开时，显示全屏背景 */
    &.has-dropdown::before {
      opacity: 1;
    }
  }
  
  /* 真正滚动时的样式调整 */
  &.header-scrolled.page-scrolled {
    padding: 0;
  }
}
.nav-box {
  max-width: 1200px;
  min-width: 900px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
  .nav-left {
    display: flex;
    align-items: center;
    .logo-box {
      width: auto;
      height: 30px;
      display: flex;
      align-items: center;
      a {
        display: flex;
        align-items: center;
        color: #fff;
      }
      .img-logo {
        width: auto;
        height: 28px;
      }
    }
    .nav-list {
      margin-left: 50px;
      height: 62px;
      width: 100%;
      .solution {
        &-main {
          ::v-deep {
            .el-submenu__title {
              padding: 0 0 0 5px;
            }
          }
        }
        
        /* 简化后的下拉菜单样式 - 只有一个背景模糊设置 */
        &-dropdown {
          display: flex;
          width: 100%;
          max-width: 1200px;
          margin: 0 auto;
          /* 唯一的背景模糊效果 */
          background: rgba(232, 232, 237, 0.4);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }
        
        &-sidebar {
          width: 320px;
          padding: 40px 30px;
          /* 移除背景，保持透明 */
          position: relative;
          
          .sidebar-decoration {
            width: 160px;
            position: absolute;
            bottom: 20px;
            right: 20px;
            opacity: 0.8;
            z-index: 0;
          }
        }
        
        &-category {
          display: flex;
          align-items: flex-start;
          margin-bottom: 32px;
          padding: 16px;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
          z-index: 10;
          
          &:hover {
            background: rgba(255, 255, 255, 0.1);
          }
          
          .category-icon {
            width: 48px;
            height: 48px;
            flex-shrink: 0;
          }
          
          .category-info {
            margin-left: 16px;
            
            &.active .category-title {
              color: #3777F6;
            }
            
            .category-title {
              color: #2D2E30;
              font-size: 16px;
              font-weight: 600;
              margin-bottom: 6px;
              display: flex;
              align-items: center;
              gap: 8px;
              
              .hot-badge {
                width: 36px;
                height: 16px;
              }
            }
            
            .category-desc {
              color: #878A90;
              font-size: 12px;
              line-height: 1.4;
            }
          }
        }
        
        &-content-area {
          flex: 1;
          padding: 40px;
          /* 移除背景，保持透明 */
        }
        
        &-search-area {
          position: relative;
          margin-bottom: 32px;
          
          .search-input {
            width: 400px;
            
            ::v-deep .el-input__inner {
              background: rgba(255, 255, 255, 0.3);
              border: 1px solid rgba(255, 255, 255, 0.3);
              border-radius: 8px;
            }
          }
          
          .search-dropdown {
            position: absolute;
            top: 45px;
            left: 0;
            width: 400px;
            background: rgba(255, 255, 255, 0.5);
            border: 1px solid rgba(255, 255, 255, 0.3);
            border-radius: 8px;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
            z-index: 999;
            overflow: hidden;
            
            .search-empty {
              padding: 20px;
              
              .empty-text {
                padding: 16px 0;
                font-size: 14px;
                color: #878A90;
                border-bottom: 1px solid rgba(217, 220, 227, 0.5);
              }
              
              .hot-title {
                padding: 16px 0;
                font-size: 14px;
                color: #5A5C60;
                display: flex;
                align-items: center;
                gap: 8px;
                
                img {
                  width: 36px;
                  height: 16px;
                }
              }
              
              .hot-tags {
                display: flex;
                flex-wrap: wrap;
                gap: 12px;
                
                .hot-tag {
                  padding: 6px 12px;
                  background: rgba(247, 248, 250, 0.3);
                  border-radius: 4px;
                  font-size: 14px;
                  color: #2D2E30;
                  cursor: pointer;
                  transition: all 0.3s ease;
                  
                  &:hover {
                    background: rgba(55, 119, 246, 0.9);
                    color: #ffffff;
                  }
                }
              }
            }
            
            .search-results {
              .results-title {
                padding: 16px 20px 8px;
                font-size: 14px;
                color: #5A5C60;
              }
              
              .result-item {
                padding: 12px 20px;
                font-size: 14px;
                color: #2D2E30;
                cursor: pointer;
                transition: all 0.3s ease;
                
                &:hover {
                  background: rgba(239, 244, 255, 0.3);
                  color: #3777F6;
                }
              }
            }
          }
          
          .quick-tag {
            display: inline-block;
            margin: 8px 12px 0 0;
            padding: 8px 16px;
            background: rgba(247, 248, 250, 0.3);
            border-radius: 6px;
            font-size: 14px;
            color: #5A5C60;
            cursor: pointer;
            transition: all 0.3s ease;
            
            &:hover {
              background: rgba(55, 119, 246, 0.9);
              color: #ffffff;
            }
          }
        }
        
        &-menus {
          .menu-panel {
            .menu-group {
              margin-bottom: 24px;
              
              .group-title {
                font-size: 16px;
                font-weight: 600;
                color: #2D2E30;
                margin-bottom: 12px;
                cursor: pointer;
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 8px 12px;
                border-radius: 6px;
                background-image: var(--my-var);
                background-repeat: no-repeat;
                background-size: 16px 16px;
                background-position: left center;
                padding-left: 24px;
                
                &:hover {
                  background-color: rgba(247, 248, 250, 0.3);
                }
                
                .hot-badge {
                  width: 36px;
                  height: 16px;
                }
              }
              
              .group-items {
                display: flex;
                flex-direction: column;
                gap: 8px;
                
                &.horizontal {
                  flex-direction: row;
                  flex-wrap: wrap;
                  gap: 16px;
                }
                
                .menu-item {
                  padding: 8px 12px;
                  font-size: 14px;
                  color: #5A5C60;
                  cursor: pointer;
                  border-radius: 6px;
                  transition: all 0.3s ease;
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  
                  &:hover {
                    background: rgba(239, 244, 255, 0.3);
                    color: #3777F6;
                  }
                  
                  .hot-badge {
                    width: 36px;
                    height: 16px;
                  }
                }
              }
            }
          }
        }
        
        /* 搜索下拉动画 */
        .slide-fade-enter-active, .slide-fade-leave-active {
          transition: all 0.3s ease;
        }
        .slide-fade-enter, .slide-fade-leave-to {
          opacity: 0;
          transform: translateY(-10px);
        }
      }
      ::v-deep .el-menu {
        border: none;
        .el-menu-item {
          height: 62px;
          line-height: 62px;
          font-weight: 500;
          border-bottom-color: rgba(0, 0, 0, 0) !important;
          &.is-active {
            border-bottom: none;
          }
          &:hover {
            background-color: rgba(0, 0, 0, 0) !important;
            color: #3777f6 !important;
          }
          &:focus, &:focus-visible {
            background-color: rgba(0, 0, 0, 0) !important;
            outline: none !important;
          }
        }
        .el-submenu {
          width: auto;
          &:hover{
            color: #3777f6 !important;
          }
          .el-submenu__title {
            height: 62px;
            line-height: 62px;
            font-weight: 500;
            border-bottom-color: rgba(0, 0, 0, 0) !important;
            &:hover {
              background-color: rgba(0, 0, 0, 0) !important;
              color: #3777F6 !important;
            }
            &:focus, &:focus-visible {
              background-color: rgba(0, 0, 0, 0) !important;
              outline: none !important;
            }
            .el-submenu__icon-arrow.el-icon-arrow-down {
              display: none;
            }
          }
          &.is-active {
            .el-submenu__title {
              border-bottom: none;
            }
          }
    
        }
      }
    }
  }
  .nav-right {
    display: flex;
    align-items: center;
    .phone {
      display: flex;
      align-items: center;
      font-weight: 500;
      .phone-img {
        width: 17px;
        height: 16px;
        margin-right: 6px;
      }
    }
    .go-experience {
      cursor: pointer;
      margin-left: 32px;
      width: 88px;
      height: 32px;
      background: #3777f6;
      line-height: 32px;
      text-align: center;
      border-radius: 2px;
      font-size: 14px;
      color: #ffffff;
      &:hover {
        background: #5f92f8;
      }
    }
  }

}

// 解决方案下拉菜单样式
::v-deep .header-nav-popup.scrolled.industry {
  background: rgba(255, 255, 255, 1) !important;
  border-radius: 0 !important;
  padding: 40px 0 !important;
  transition: opacity 0.2s ease-out, transform 0.2s ease-out !important;
  transform-origin: top center !important;
  min-width: 100vw !important;
  width: 100vw !important;
  max-width: 100vw !important;
  left: 0 !important;
  right: 0 !important;
  margin-left: calc(-50vw + 50%) !important;
  overflow: visible !important;
  position: fixed !important;
  top: 58px !important;
  z-index: 1000 !important;
}

// 移除解决方案下拉菜单的内层阴影（避免双重阴影）
::v-deep .industry-main .el-submenu__popup {
  box-shadow: none !important;
  border: none !important;
}

::v-deep .industry-main .el-menu--popup {
  box-shadow: none !important;
  border: none !important;
}

.industry-popup {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  .industry-content {
    padding: 24px 0 40px 0;
    .category-section {
      margin-bottom: 48px;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      .category-title {
        font-size: 20px;
        font-weight: 600;
        color: #2D2E30;
        margin: 0 0 24px 0;
        text-align: left;
      }
    }
    
    .solution-list {
      display: flex;
      gap: 24px;
      justify-content: space-between;
      flex-wrap: nowrap;
      align-items: flex-start;
      
      .solution-item {
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: all 0.3s ease;
        padding: 16px;
        border-radius: 8px;
        flex: 1;
        min-width: 0;
      
        &:hover {
          background: #F2F5FF !important;
          .solution-title {
            color: #3777F6 !important;
          }
        }
        
        .solution-image {
          width: 48px;
          height: 48px;
          margin-right: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          
          img {
            width: 48px;
            height: 48px;
            object-fit: contain;
          }
        }
      
        .solution-info {
          flex: 1;
          min-width: 0;
          
          .solution-title {
            font-size: 16px;
            font-weight: 600;
            color: #2D2E30;
            margin: 0 0 4px 0;
            line-height: 1.4;
            transition: color 0.3s ease;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          
          .solution-subtitle {
            font-size: 12px;
            font-weight: 400;
            color: #878A90;
            margin: 0;
            line-height: 1.4;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}

::v-deep .header-nav-popup.scrolled.new-product {
  background: rgba(255, 255, 255, 1) !important;
  border-radius: 0 !important;
  padding: 0 !important;
  transition: opacity 0.2s ease-out, transform 0.2s ease-out !important;
  transform-origin: top center !important;
  min-width: 100vw !important;
  width: 100vw !important;
  max-width: 100vw !important;
  left: 0 !important;
  right: 0 !important;
  margin-left: calc(-50vw + 50%) !important;
  overflow: visible !important;
  position: fixed !important;
  top: 58px !important;
  z-index: 1000 !important;
}

// 移除新产品下拉菜单的内层阴影（避免双重阴影）
::v-deep .new-product-main .el-submenu__popup {
  box-shadow: none !important;
  border: none !important;
}

::v-deep .el-popper[x-placement^="bottom"] .popper__arrow {
  display: none !important;
}

::v-deep .new-product-main .el-menu--popup {
  box-shadow: none !important;
  border: none !important;
}

.new-product-popup {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  .new-product-content {
    padding: 0;
    .product-sections-wrapper {
      display: flex;
      gap: 48px;
      position: relative;
      
      &::after {
        content: '';
        position: absolute;
        left: 320px;
        top: 0;
        bottom: 0;
        width: 1px;
        background-color: #eeeeee;
      }
      
      .category-section {
        .category-title {
          font-size: 20px;
          font-weight: 600;
          color: #2D2E30;
          margin: 0 0 24px 0;
          text-align: left;
        }
        
                  &.left-section {
          width: 320px;
          flex-shrink: 0;
          padding-right: 24px;
          
          .product-list.vertical {
            display: flex;
            flex-direction: column;
            gap: 16px;
            
            .product-item {
              display: flex;
              align-items: center;
              cursor: pointer;
              transition: all 0.3s ease;
              padding: 12px;
              border-radius: 8px;
              
              &:hover {
                background: #F2F5FF !important;
                .product-title {
                  color: #3777F6 !important;
                }
              }
              
                              .product-image {
                  width: 32px;
                  height: 32px;
                  margin-right: 12px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-shrink: 0;
                  
                  img {
                    width: 32px;
                    height: 32px;
                    object-fit: contain;
                  }
                }
              
              .product-info {
                flex: 1;
                min-width: 0;
                
                .product-title {
                  font-size: 16px;
                  font-weight: 600;
                  color: #2D2E30;
                  margin: 0 0 4px 0;
                  line-height: 1.4;
                  transition: color 0.3s ease;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                
                .product-subtitle {
                  font-size: 12px;
                  font-weight: 400;
                  color: #878A90;
                  margin: 0;
                  line-height: 1.4;
                  white-space: normal;
                  word-wrap: break-word;
                  word-break: break-all;
                }
              }
            }
          }
        }
        
                  &.right-section {
          flex: 1;
          min-width: 0;
          padding-left: 24px;
          margin-left: -24px;
          
          .category-divider {
            height: 1px;
            background-color: rgba(217, 220, 227, 0.8);
            margin: 24px 0;
            width: 100%;
          }
          
          .product-list.grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 24px;
            
            .product-item-with-sub {
              margin-left: -8px;
              
              .product-item {
                display: flex;
                align-items: center;
                cursor: pointer;
                transition: all 0.3s ease;
                padding: 12px;
                border-radius: 8px;
                
                &:hover {
                  background: #F2F5FF !important;
                  .product-title {
                    color: #3777F6 !important;
                  }
                }
                
                &.no-click {
                  cursor: default;
                  
                  &:hover {
                    background-color: transparent;
                    .product-title {
                      color: #2D2E30;
                    }
                  }
                }
                
                .product-image {
                  width: 48px;
                  height: 48px;
                  margin-right: 12px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-shrink: 0;
                  
                  img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                  }
                }
                
                .product-info {
                  flex: 1;
                  min-width: 0;
                  
                  .product-title {
                    font-size: 16px;
                    font-weight: 600;
                    color: #2D2E30;
                    margin: 0 0 4px 0;
                    line-height: 1.4;
                    transition: color 0.3s ease;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                  
                  .product-subtitle {
                    font-size: 12px;
                    font-weight: 400;
                    color: #878A90;
                    margin: 0;
                    line-height: 1.4;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                }
              }
              
              .sub-options {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                gap: 8px;
                margin-top: 8px;
                padding-left: 12px;
                
                .sub-option {
                  cursor: pointer !important;
                  padding: 4px 8px !important;
                  border-radius: 4px !important;
                  background-color: #F8F9FA !important;
                  transition: all 0.3s ease !important;
                  flex: 0 0 calc(50% - 4px);
                  
                  &:hover {
                    background: rgba(239, 244, 255, 0.3) !important;
                  }
                  
                  .sub-option-text {
                    font-size: 14px !important;
                    font-weight: 400 !important;
                    color: #5A5C60 !important;
                    line-height: 1.4 !important;
                    transition: color 0.3s ease !important;
                  }
                  
                  &:hover .sub-option-text {
                    color: #3777F6 !important;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// 加速Element UI下拉菜单动画，保持从上往下的效果
::v-deep .el-zoom-in-top-enter-active,
::v-deep .el-zoom-in-top-leave-active {
  transition: opacity 0.2s ease-out, transform 0.2s ease-out !important;
}

::v-deep .el-zoom-in-top-enter,
::v-deep .el-zoom-in-top-leave-to {
  opacity: 0 !important;
  transform: scaleY(0) translateY(-20px) !important;
  transform-origin: top center !important;
}

// 覆盖Element UI submenu的默认过渡
::v-deep .el-submenu .el-menu--popup {
  transition: opacity 0.2s ease-out, transform 0.2s ease-out !important;
  transform-origin: top center !important;
}

// 移除Element UI下拉菜单容器的默认阴影
::v-deep .el-menu--horizontal.header-nav-popup {
  box-shadow: none !important;
}

@import '@/assets/scss/min-index.scss';

// 解决方案下拉菜单（旧版本兼容）
::v-deep .header-nav-popup.scrolled.solution {
  background: rgba(255, 255, 255, 1) !important;
  border-radius: 0 !important;
  padding: 40px 0 !important;
  transition: opacity 0.2s ease-out, transform 0.2s ease-out !important;
  transform-origin: top center !important;
  min-width: 100vw !important;
  width: 100vw !important;
  max-width: 100vw !important;
  left: 0 !important;
  right: 0 !important;
  margin-left: calc(-50vw + 50%) !important;
  overflow: visible !important;
  position: fixed !important;
  top: 58px !important;
  z-index: 1000 !important;
}
</style>